import { PUSHER_MESSAGE_RECEIVED } from './actionTypes';

export const pusherMessageReceived = (message) => ({ type: PUSHER_MESSAGE_RECEIVED, payload: message });